var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import utils from "../../../../utils";
import { BaseInput } from "../BaseInput";
export var IBANWidget = function (_a) {
    var onChange = _a.onChange, value = _a.value, props = __rest(_a, ["onChange", "value"]);
    var printValue = 
    // eslint-disable-next-line no-nested-ternary
    !value || value === ""
        ? "BE"
        : value.includes("*")
            ? value
            : utils.iban.IBAN.printFormat(value);
    var handleChange = function (value) {
        return onChange(value ? value.replace(/[_\s]/g, "") : "");
    };
    return (_jsx(BaseInput, __assign({ value: printValue }, props, { onChange: handleChange, mask: utils.iban.ibanMask, pipe: utils.iban.ibanPipe })));
};
